import { render, staticRenderFns } from "./RadioInputRenderer.vue?vue&type=template&id=0c884070&scoped=true"
import script from "./RadioInputRenderer.vue?vue&type=script&lang=js"
export * from "./RadioInputRenderer.vue?vue&type=script&lang=js"
import style0 from "./RadioInputRenderer.vue?vue&type=style&index=0&id=0c884070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c884070",
  null
  
)

export default component.exports